import type { AllPageFilters } from "./AllPageFilters";
import { AllPageSearchParamKey } from "./AllPageSearchParamKey";
import { CommonSearchParamKey } from "./CommonSearchParamKey";
import { buildRegionParamValue } from "./buildRegionParamValue";

/**
 * TODO: 중고거래 필터 관련 로직 `/services/buy-sell/` 하위로 위치해야함
 */
export function buildAllPageParams(
  args: Parameters<typeof buildRegionParamValue>[0] & AllPageFilters,
) {
  const searchParams = new URLSearchParams();

  searchParams.set(
    CommonSearchParamKey.In,
    buildRegionParamValue({
      region: args.region,
    }),
  );

  if (args.categoryId) {
    searchParams.set(AllPageSearchParamKey.CategoryId, args.categoryId);
  }
  if (args.price) {
    searchParams.set(AllPageSearchParamKey.Price, args.price);
  }
  if (args.search) {
    searchParams.set(AllPageSearchParamKey.Search, args.search);
  }

  return searchParams;
}
